/* eslint-disable react/display-name */
import React from 'react';

const withErrorHandler = (WrappedComponent, axios) => {
  return props => {
    const reqInteceptors = axios.interceptors.request.use(req => {
      return req;
    });

    const resInterceptors = axios.interceptors.response.use(res => {
      return res;
    });

    const errInterceptors = axios.interceptors.response.use(
      res => res,
      error => {
        return error.response;
      }
    );

    React.useEffect(() => {
      return () => {
        axios.interceptors.request.eject(reqInteceptors);
        axios.interceptors.response.eject(resInterceptors);
        axios.interceptors.response.eject(errInterceptors);
      };
    }, [reqInteceptors, resInterceptors, errInterceptors]);

    return (
      <>
        <WrappedComponent {...props} />
      </>
    );
  };
};

export default withErrorHandler;
